import { MODAL_REDUCER } from './reducer';

export const activeModalSelector = (state) => state[MODAL_REDUCER].activeModal;
export const activeModalPropsSelector = (state) => state[MODAL_REDUCER].props;

export const hasActiveModal = (state) => !!activeModalSelector(state);
